import { Link, useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';

import { cn } from '@/helpers/shadcn';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/app/ui/tooltip';

// A single icon link in the rail with a hover tooltip showing its label. Used for
// the simple destinations (Dashboard, Project, Market, Precon, Settings, Updates).
// `locked` marks a destination the company is not entitled to — it still links, but
// to the feature's upsell page rather than the feature.
const NavItem = ({ to, label, icon: Icon, testId, indicatorCount = 0, locked = false, featureId, onClick }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);
  const indicatorLabel = indicatorCount > 9 ? '9+' : String(indicatorCount);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to={to}
          data-testid={testId}
          data-active={isActive}
          data-feature-id={featureId}
          onClick={onClick}
          className={cn(
            'relative flex size-11 items-center justify-center rounded-xl text-muted-foreground transition-colors ',
            isActive && 'bg-primary/10 dark:bg-secondary/10 text-primary dark:text-secondary',
            !isActive && 'hover:bg-accent hover:text-foreground'
          )}
        >
          <Icon className="size-5" />
          {locked && (
            <span
              data-testid={`${testId}-locked`}
              className="bg-muted text-muted-foreground ring-sidebar absolute -right-0.5 top-0.5 flex size-4 items-center justify-center rounded-full ring-2"
            >
              <Lock className="size-2.5" />
            </span>
          )}
          {indicatorCount > 0 && (
            <span
              data-testid={`${testId}-indicator`}
              className="absolute -right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium leading-none text-destructive-foreground ring-2 ring-sidebar"
            >
              {indicatorLabel}
            </span>
          )}
          <span className="sr-only">{indicatorCount > 0 ? `${label}, ${indicatorCount} unseen` : label}</span>
        </Link>
      </TooltipTrigger>
      <TooltipContent side="right">{locked ? `${label} — Preview` : label}</TooltipContent>
    </Tooltip>
  );
};

export default NavItem;
